/* ==========================================================================
   ceq-drawer-cross-sell.js
   Custom Element <ceq-drawer-cross-sell> fuer «Andere kauften auch» im
   Warenkorb-Drawer (gerendert von snippets/ceq-drawer-cross-sell.liquid,
   geladen von snippets/cart-drawer.liquid).

   - Testgruppe: Hat der Warenkorb noch keine (data-arm leer), wird sie beim
     ersten Oeffnen des Drawers nach den Anteilen im Theme-Editor ausgelost
     (A / B / 0 = Kontrolle), sofort eingeblendet und als Warenkorb-Attribut
     `_drawer_xs` gespeichert. Das Attribut wandert beim Kauf auf die Bestellung.
   - Hinzufuegen: legt genau die gezeigte Variante mit der versteckten
     Line-Item-Property `_drawer_xs` (= Gruppe) in den Warenkorb und rendert
     den Drawer neu.
   - GA4: `drawer_xs_view_<gruppe>` beim Oeffnen des Drawers (einmal je
     Seitenaufruf, auch fuer die Kontrollgruppe — sie ist der Nenner),
     `drawer_xs_add_<gruppe>` beim Hinzufuegen. Die Gruppe steckt im
     Event-Namen, damit keine benutzerdefinierte GA4-Dimension noetig ist.
     Sende-Weg wie assets/ceq-turf-track.js (gtag ohne send_to, dataLayer-Fallback).
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('ceq-drawer-cross-sell')) return;

  // Page-weit: eine einmal geloste Gruppe gilt, auch wenn der Drawer neu rendert,
  // bevor das Speichern im Warenkorb zurueck ist.
  let pageArm = '';
  const viewed = new Set();

  function track(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  // Beim Oeffnen: Gruppe erst jetzt auslosen (nur Warenkoerbe, deren Drawer jemand
  // wirklich sieht, kommen in den Test), dann den Blick melden.
  function onOpen() {
    const el = document.querySelector('ceq-drawer-cross-sell');
    if (!el || typeof el.assign !== 'function') return;
    if (!el.arm) el.assign();
    if (viewed.has(el.arm)) return;
    viewed.add(el.arm);
    track('drawer_xs_view_' + el.arm.toLowerCase(), { anchor: el.dataset.anchor || '' });
  }

  // Oeffnen des Drawers = Klasse `active` auf <cart-drawer>.
  function observeDrawer() {
    const d = drawer();
    if (!d || d.dataset.dxsObserved) return;
    d.dataset.dxsObserved = '1';
    new MutationObserver(() => {
      if (d.classList.contains('active')) onOpen();
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  customElements.define(
    'ceq-drawer-cross-sell',
    class CeqDrawerCrossSell extends HTMLElement {
      connectedCallback() {
        this.arm = this.dataset.arm || '';

        this.querySelectorAll('[data-dxs-add]').forEach((button) => {
          button.addEventListener('click', () => this.add(button));
        });

        observeDrawer();
        const d = drawer();
        if (d && d.classList.contains('active')) onOpen();
      }

      assign() {
        let arm = pageArm;
        if (!arm) {
          const pctA = Number(this.dataset.pctA) || 0;
          const pctB = Number(this.dataset.pctB) || 0;
          const roll = Math.random() * 100;
          arm = roll < pctA ? 'A' : roll < pctA + pctB ? 'B' : '0';
          pageArm = arm;
        }
        this.arm = arm;
        this.dataset.arm = arm;

        this.querySelectorAll('[data-dxs-group]').forEach((group) => {
          if (group.dataset.dxsGroup === arm) group.hidden = false;
          else group.remove();
        });

        const url = (window.routes && window.routes.cart_update_url) || '/cart/update';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _drawer_xs: arm } }),
        }).catch((e) => console.error('[ceq-drawer-cross-sell]', e));
      }

      add(button) {
        if (button.classList.contains('is-loading')) return;
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');

        const cart = drawer();
        const body = {
          items: [
            {
              id: parseInt(button.dataset.variantId, 10),
              quantity: 1,
              properties: { _drawer_xs: this.arm },
            },
          ],
        };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'ceq-drawer-cross-sell',
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              button.classList.remove('is-loading');
              button.removeAttribute('aria-disabled');
              return;
            }

            track('drawer_xs_add_' + this.arm.toLowerCase(), {
              anchor: this.dataset.anchor || '',
              variant_id: button.dataset.variantId,
              value: (Number(button.dataset.price) || 0) / 100,
              currency: 'CHF',
            });

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ceq-drawer-cross-sell', cartData: response });
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error('[ceq-drawer-cross-sell]', e);
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
})();
